import axios from '@utils/axios'

export interface TradeApplicationDTO {
  company: string
  website: string
  address1: string
  address2: string
  city: string
  state: string | null
  zip: string
  country: string
  years_in_business: string
  state_registration_number: string | null
  tax_exempt_id: string | null
  vat_id: string | null
  profession: string
  trade_newsletter: boolean
  bypass_documents: boolean
  business_card_document: File | undefined
  document: File | undefined
}

export interface UploadTradeDocumentDTO {
  document: File | undefined
}

export const sendTradeApplyRequest = (data: TradeApplicationDTO) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  }

  return axios.post('/api/trade/apply', { ...data }, config)
}

export const sendUploadTradeDocumentRequest = (data: UploadTradeDocumentDTO) => {
  const config = {
    headers: {
      'content-type': 'multipart/form-data',
    },
  }

  return axios.post('/api/trade/documents/upload', { ...data }, config)
}
